// pp-calc-camioneta.js — ¿Cuántas Cajas Caben en mi Camioneta o Camión?
// (/pages/cuantas-cajas-caben-en-una-camioneta)
//
// Acomodo SIMPLE a propósito: probamos las DOS orientaciones horizontales de
// la caja (l×w y w×l) sobre el piso del área de carga, nos quedamos con la
// mejor, y multiplicamos por las camas que caben de altura. Sin bandas mixtas
// ni programación dinámica (eso vive en pp-calc-tarima.js): en una camioneta
// el cargador acomoda en bloque parejo, con prisa, y ese es el número honesto.
//
// Las medidas de los vehículos son TÍPICAS DE REFERENCIA — cada versión y
// año cambia; el usuario las edita con las de SU unidad. No son datos de
// ningún fabricante.
//
// La aritmética vive aquí (no en la sección) para probarse con node a secas
// en tests/calc-camioneta.test.mjs.
(function (root) {
  'use strict';

  // Medidas típicas del área de carga (cm) y carga útil típica (kg).
  // Valores de referencia redondeados de la clase de vehículo, NO de un
  // modelo específico — el usuario siempre puede corregirlos.
  var VEHICULOS = {
    moto: { l: 40, w: 40, h: 40, cargaKg: 30 },
    sedan: { l: 100, w: 95, h: 50, cargaKg: 400 },
    pickup: { l: 150, w: 140, h: 50, cargaKg: 1000 },
    van_chica: { l: 180, w: 125, h: 120, cargaKg: 600 },
    van_mediana: { l: 250, w: 150, h: 130, cargaKg: 1200 },
    van_grande: { l: 300, w: 175, h: 180, cargaKg: 1400 },
    estaquitas: { l: 250, w: 170, h: 150, cargaKg: 1500 },
    caja_35: { l: 420, w: 210, h: 210, cargaKg: 3500 },
    rabon: { l: 650, w: 240, h: 240, cargaKg: 8000 },
    torton: { l: 750, w: 250, h: 250, cargaKg: 15000 },
    caja_48: { l: 1450, w: 250, h: 270, cargaKg: 22000 },
    trailer_53: { l: 1600, w: 250, h: 270, cargaKg: 26000 }
  };

  // Cálculo completo. Todo en cm y kg.
  //   cajaL, cajaW, cajaH — medidas EXTERIORES de la caja
  //   vehL, vehW, vehH    — área de carga del vehículo
  //   pesoCaja (opcional) — kg por caja llena
  //   cargaUtilKg (opcional) — carga útil del vehículo, para la advertencia
  function calcularCamioneta(e) {
    if (!e) return null;
    var cl = n(e.cajaL), cw = n(e.cajaW), ch = n(e.cajaH);
    var vl = n(e.vehL), vw = n(e.vehW), vh = n(e.vehH);
    if ([cl, cw, ch, vl, vw, vh].some(function (v) { return v === null || v <= 0; })) return null;

    // Las dos orientaciones horizontales: l a lo largo, o girada 90°.
    var normal = { nx: Math.floor(vl / cl), ny: Math.floor(vw / cw), girada: false };
    var girada = { nx: Math.floor(vl / cw), ny: Math.floor(vw / cl), girada: true };
    var mejor = (normal.nx * normal.ny >= girada.nx * girada.ny) ? normal : girada;
    var porCama = mejor.nx * mejor.ny;
    if (porCama === 0) return { error: 'caja_no_cabe' };

    var camas = Math.floor(vh / ch);
    if (camas === 0) return { error: 'altura_insuficiente' };

    var total = porCama * camas;
    var r = {
      porCama: porCama,
      filas: mejor.nx,
      columnas: mejor.ny,
      girada: mejor.girada,
      camas: camas,
      total: total,
      aprovechamientoPct: (total * cl * cw * ch) / (vl * vw * vh) * 100,
      advertencias: []
    };

    var pesoCaja = n(e.pesoCaja);
    if (pesoCaja !== null && pesoCaja > 0) {
      r.pesoTotal = total * pesoCaja;
      var cargaUtil = n(e.cargaUtilKg);
      if (cargaUtil !== null && cargaUtil > 0) {
        r.cargaUtilKg = cargaUtil;
        if (r.pesoTotal > cargaUtil) r.advertencias.push('peso');
      }
    }
    return r;
  }

  function n(x) {
    if (x === null || x === undefined || x === '') return null;
    var v = Number(String(x).replace(',', '.'));
    return isFinite(v) ? v : null;
  }

  root.PPCalcCamioneta = {
    VEHICULOS: VEHICULOS,
    calcularCamioneta: calcularCamioneta
  };
})(typeof window !== 'undefined' ? window : globalThis);

// ── Wiring de la página (no corre en tests de node) ────────────────────────
(function () {
  'use strict';
  if (typeof document === 'undefined') return;

  function listo(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  listo(function () {
    var raiz = document.querySelector('[data-pp-calc-camioneta]');
    if (!raiz) return;
    var C = window.PPCalcCamioneta;
    var $ = function (sel) { return raiz.querySelector(sel); };
    var form = $('form');
    var out = $('[data-calc-resultado]');

    // Al elegir vehículo se PRECARGAN las medidas típicas en los tres inputs
    // editables — el usuario las corrige con las de su unidad. "Otra" los
    // limpia para capturar desde cero.
    var selVehiculo = $('[name="vehiculo"]');
    var inpL = $('[name="veh_l"]'), inpW = $('[name="veh_w"]'), inpH = $('[name="veh_h"]');
    if (selVehiculo && inpL && inpW && inpH) {
      selVehiculo.addEventListener('change', function () {
        var v = C.VEHICULOS[selVehiculo.value];
        if (v) {
          inpL.value = v.l; inpW.value = v.w; inpH.value = v.h;
        } else {
          inpL.value = ''; inpW.value = ''; inpH.value = '';
          inpL.focus();
        }
      });
    }

    function fmt(x, dec) {
      return x.toLocaleString('es-MX', { maximumFractionDigits: dec === undefined ? 0 : dec });
    }

    function correr() {
      var f = new FormData(form);
      var veh = C.VEHICULOS[f.get('vehiculo')];
      var r = C.calcularCamioneta({
        cajaL: f.get('caja_l'), cajaW: f.get('caja_w'), cajaH: f.get('caja_h'),
        vehL: f.get('veh_l'), vehW: f.get('veh_w'), vehH: f.get('veh_h'),
        pesoCaja: f.get('peso_caja'),
        cargaUtilKg: veh ? veh.cargaKg : null
      });
      pintar(r);
      dibujar3d(r, f);
    }

    function pintar(r) {
      if (!out) return;
      out.hidden = false;
      if (!r) {
        out.innerHTML = '<p class="pp-calc__error">Revisa los datos: medidas de la caja y del área de carga deben ser mayores a cero.</p>';
        return;
      }
      if (r.error === 'caja_no_cabe') {
        out.innerHTML = '<p class="pp-calc__error">La caja es más grande que el piso del área de carga — no cabe ni una. Revisa las medidas (¿capturaste metros en lugar de centímetros?).</p>';
        return;
      }
      if (r.error === 'altura_insuficiente') {
        out.innerHTML = '<p class="pp-calc__error">La caja es más alta que el área de carga — no cabe ni una cama. Revisa el alto de tu caja y el del vehículo.</p>';
        return;
      }

      var html = '<div class="pp-calc__veredicto pp-calc__veredicto--ok">';
      html += '<p class="pp-calc__veredicto-titulo">Caben ' + fmt(r.total) + ' cajas en el área de carga</p>';
      html += '<p class="pp-calc__veredicto-dato"><strong>' + fmt(r.porCama) + ' cajas por cama × ' + fmt(r.camas) + ' camas</strong> · acomodo de ' + fmt(r.filas) + ' a lo largo × ' + fmt(r.columnas) + ' a lo ancho' + (r.girada ? ' (con la caja girada 90°)' : '') + '.</p>';
      html += '</div>';

      html += '<dl class="pp-calc__detalle">';
      html += par('Volumen del área de carga aprovechado', fmt(r.aprovechamientoPct, 1) + '%');
      if (r.pesoTotal) html += par('Peso total estimado de la carga', fmt(r.pesoTotal) + ' kg');
      if (r.cargaUtilKg) html += par('Carga útil típica del vehículo elegido', '≈ ' + fmt(r.cargaUtilKg) + ' kg');
      html += '</dl>';

      if (r.advertencias.indexOf('peso') !== -1) {
        html += '<p class="pp-calc__nota">Ojo: el peso total pasa de la carga útil típica de este vehículo. Aunque el volumen sobre, la suspensión y los frenos no — reparte en más viajes o sube de unidad. Verifica la carga útil real en la tarjeta de circulación de tu unidad.</p>';
      }
      html += '<p class="pp-calc__nota">Acomodo en bloque parejo, sin acomodos mixtos — lo que un cargador hace en la vida real con prisa. Rines de la caja, huecos de puerta y cajas que no se estiban de más por peso comen espacio: toma el número como techo, no como promesa.</p>';
      out.innerHTML = html;

      function par(t, v) { return '<div class="pp-calc__detalle-fila"><dt>' + t + '</dt><dd>' + v + '</dd></div>'; }
    }

    // El área de carga con las cajas estibadas, en 3D girable (motor
    // compartido pp-caja-3d). Reconstruimos las posiciones del acomodo
    // simple: filas × columnas × camas, con la orientación ganadora.
    function dibujar3d(r, f) {
      var cont = raiz.querySelector('[data-calc-dibujo-3d]');
      if (!cont || !window.PPCaja3D || !window.PPCaja3D.montar) return;
      if (!r || r.error) { cont.hidden = true; return; }
      cont.hidden = false;
      var cl = Number(String(f.get('caja_l')).replace(',', '.'));
      var cw = Number(String(f.get('caja_w')).replace(',', '.'));
      var ch = Number(String(f.get('caja_h')).replace(',', '.'));
      var vl = Number(String(f.get('veh_l')).replace(',', '.'));
      var vw = Number(String(f.get('veh_w')).replace(',', '.'));
      var vh = Number(String(f.get('veh_h')).replace(',', '.'));
      var bl = r.girada ? cw : cl;
      var bw = r.girada ? cl : cw;
      var piezas = [];
      var TOPE = 260;
      var camasDibujadas = 0;
      for (var cama = 0; cama < r.camas; cama++) {
        if (piezas.length + r.porCama > TOPE) break;
        for (var i = 0; i < r.filas; i++) {
          for (var j = 0; j < r.columnas; j++) {
            piezas.push({
              dims: [bl, bw, ch],
              pos: [i * bl, cama * ch, j * bw],
              color: cama % 2
            });
          }
        }
        camasDibujadas++;
      }
      window.PPCaja3D.montar(cont, {
        caja: [vl, vw, vh],
        piezas: piezas,
        etiqueta: 'Tu carga en 3D — arrástrala para girarla. Área de carga de ' + fmt(vl) + ' × ' + fmt(vw) + ' × ' + fmt(vh) + ' cm' +
          (camasDibujadas < r.camas ? ' (se dibujan ' + camasDibujadas + ' de ' + fmt(r.camas) + ' camas)' : '')
      });
    }

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      correr();
      if (out) out.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });

    // Con el resultado ya visible, editar cualquier campo recalcula solo.
    var timerRecalc = null;
    function recalcEnVivo() {
      if (!out || out.hidden) return;
      clearTimeout(timerRecalc);
      timerRecalc = setTimeout(function () { correr(); }, 350);
    }
    form.addEventListener('input', recalcEnVivo);
    form.addEventListener('change', recalcEnVivo);
  });
})();
